import api from '../../../api/index';

export default {
  cleanUserData({ commit }) {
    commit('setUserId', 0);
    commit('setMemberType', 100);
  },
  sendRecoveryPasswordEmail({}, email) {
    return api.post('/recover-password', { email });
  },
};
